export enum FieldDataSourceType {
  None = -1,
  UserDefined = 0,
  Module = 1,
  SystemString = 2,
  SystemInteger = 3
}

export enum FieldDataSourceSystemDictionaries {
  Addresses = -1019,
  GlobalAddresses = -1021,
};